var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGreenBgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 101 101"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 50.544,
  cy: 50.604,
  r: 50,
  fill: "#D7ECC2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#496F23",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 5,
  d: "M30.093 52.774 42.29 65.035l28.706-28.862"
})));
export { SvgGreenBgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCAxMDEgMTAxIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPGNpcmNsZSBjeD0iNTAuNTQ0MiIgY3k9IjUwLjYwNCIgcj0iNTAiIGZpbGw9IiNEN0VDQzIiLz4KICAgIDxwYXRoIGQ9Ik0zMC4wOTM1IDUyLjc3MzdMNDIuMjg4NyA2NS4wMzU0TDcwLjk5NSAzNi4xNzI2IiBzdHJva2U9IiM0OTZGMjMiIHN0cm9rZS13aWR0aD0iNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";